module.exports = new __parcel__URL__("what-if.e2b9918f.jpg").toString();